import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAdminAuth } from "./AdminAuth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error("Login failed", {
        description: err?.response?.data?.detail || "Check your email and password.",
      });
    } finally {
      setBusy(false);
    }
  }

  const field =
    "w-full rounded-lg border bg-transparent px-3 py-2.5 text-sm outline-none focus:border-[color:var(--nq-gold)]";
  const bd = { borderColor: "rgba(255,255,255,0.14)" };

  return (
    <div className="flex min-h-screen items-center justify-center p-4" style={{ background: "var(--nq-black)" }}>
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <ShieldCheck className="mx-auto h-10 w-10 gold-text" />
          <h1 className="mt-3 text-2xl font-bold">
            NQ<span className="gold-text">SPRINGS</span> Admin
          </h1>
          <p className="mt-1 text-sm text-[color:var(--nq-stone)]">Sign in to manage your site</p>
        </div>

        <form className="card-nq space-y-4 p-6" onSubmit={submit} data-testid="admin-login-form">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-[color:var(--nq-stone)]">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={field}
              style={bd}
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-[color:var(--nq-stone)]">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={field}
              style={bd}
              data-testid="admin-password-input"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full px-6 py-3 disabled:opacity-60" data-testid="admin-login-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
